// Module
var code = `<template>
  <require from="./profit-loss-period-widget.scss"></require>
  <require from="../../../converters/column-widths-converter"></require>

  <div class="profit-loss-period-widget profit-loss-period-widget-\${id}">
    <!-- beautify ignore:start -->
    <style if.bind="rowHeight">
      .profit-loss-period-widget-\${id} tr {
        height: \${rowHeight}px !important;
      }
    </style>

    <style>
      .profit-loss-period-widget-\${id} td {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .profit-loss-period-widget-\${id} th {
        font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
        font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th style="\${columnWidths | columnWidths:0}">Instrument name</th>
          <th style="\${columnWidths | columnWidths:1}" class="widget-table__numeric">Realized P&L</th>
          <th style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">Unrealized P&L</th>
          <th style="\${columnWidths | columnWidths:3}" class="widget-table__numeric">Interest</th>
          <th style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">Dividend</th>
          <th style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">Total P&L</th>
          <th style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">Repayment</th>
          <th style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">Total</th>
        </tr>
      </thead>
      <tbody>
        <template repeat.for="v of instrumentValues">
          <tr class="\${v === total ? 'widget-table__total' : ''} \${v.group1Total ? 'widget-table__group-total' : ''} \${v.group1Header ? 'widget-table__group-header' : ''}">
            <td style="\${columnWidths | columnWidths:0}; padding-left: \${v.indent}px">
              \${v.name}
            </td>

            <template if.bind="!groupHeader">

              <td style="\${columnWidths | columnWidths:1}" class="widget-table__numeric">
                \${v.realizedProfitLossChangeInPeriod | numericFormatter:quantityPrecision}
              </td>

              <td style="\${columnWidths | columnWidths:2}" class="widget-table__numeric">
                \${v.unrealizedProfitLossChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:3}" class="widget-table__numeric">
                \${v.interestChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:4}" class="widget-table__numeric">
                \${v.dividendChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:5}" class="widget-table__numeric">
                \${v.profitLossChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:6}" class="widget-table__numeric">
                \${v.repaymentChangeInPeriod | numericFormatter:precision}
              </td>

              <td style="\${columnWidths | columnWidths:7}" class="widget-table__numeric">
                \${v.profitLossChangeInPeriod + v.repaymentChangeInPeriod | numericFormatter:precision}
                <promise-resolver resolve.bind="lastItemRendered" if.bind="\$last"></promise-resolver>
              </td>

            </template>
          </tr>
        </template>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;